import { initialEventDetailsState } from "./EventDetails/EventDetailsState";
import { initialEventOverviewState } from "./EventOverview/EventOverviewState";
export const defaultEventsConfig = {
    prefix: window.eventsPrefix || '/agenda',
    overviewPage: {
        // Same default as the backend's Events:OverviewPageSize
        pageSize: window.eventsOverviewPageSize || 5,
        locationFilter: {
            kind: 'region',
            heading: 'Locatie',
            defaultLabel: 'Alle locaties'
        }
    },
    detailPage: {
        classNames: {
            page: (_)=>[]
        },
        collapsePrimaryContent: true,
        pageSize: 8,
        fallbackToHeaderAsPrimary: false,
        copy: {
            noTicketRequired: 'Gratis, kom langs!'
        }
    }
};
export const branchBasedLocationFilter = {
    locationFilter: {
        kind: 'location',
        heading: 'Locatie',
        defaultLabel: 'Alle locaties'
    }
};
export const initialEventsApplicationState = {
    eventDetails: initialEventDetailsState,
    eventOverview: initialEventOverviewState
};
